<div role="main" *appIfFeature="'feature_hero'">
  <div class="hero hero-bgimage d-flex flex-column align-items-center justify-content-between" *ngIf="showHero">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="d-flex flex-column align-items-center justify-content-between">
            <h1 class="text-white text-center mx-4">Software product downloads</h1>
            <div>
              <h2 class="text-white text-center m-0 mb-5">Software product downloads are now available</h2>
              <p class="text-white text-center mb-0">We are migrating software product downloads to this site.</p>
              <p class="text-white text-center mb-0">
                When complete, all software product downloads and data updates will be available by selecting My
                Software Products or My Data Products links.
              </p>
            </div>

            <div class="d-flex flex-column flex-md-row justify-content-start align-items-center"></div>
          </div>
          <div class="d-flex flex-column align-items-center mt-4">
            <button
              id="btnGotIt"
              class="mat-ripple btn btn-glass mb-3 btn-got-it"
              style="min-width: 7rem"
              (click)="gotIt()"
            >
              Got It
            </button>
            <p>
              <button id="remindMe" class="btn btn-link text-white border-0" (click)="remindMeLater()">
                Remind me later
              </button>
            </p>
          </div>
          <div class="d-flex flex-column align-items-center mb-4">
            <div class="text-white text-center mb-0" id="note">
              NOTE: If you are unable to locate your software products on this site,
              <a class="custom-link" target="_blank" href="https://customer.precisely.com/">create a customer case</a>
              (partners,
              <a class="custom-link" target="_blank" href="https://partner.precisely.com/">create a partner case</a>).
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
